import {
  CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION,
  DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION,
  EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION,
  RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS,
  REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS,
  REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION,
} from '@sophocles/entities/RelayControllerFirmwareVersion/relayControllerFirmwareVersionActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS: // Read
      return state.merge(action.relayControllerFirmwareVersions);
    case DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION: // Delete
      return state.delete(action.relayControllerFirmwareVersion.toString());
    case EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION: // Update
    case CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION: // Create
    case REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION:
    case REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS:
    default:
      return state;
  }
}

export function relayControllerFirmwareVersionReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION:
    case DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION:
    case RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS:
    case EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION:
    case REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION:
    case REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS:
      return getState(state, action);
    default:
      return state;
  }
}
